import React from "react"
import './footer.css'
import facebook from '../../assets/icon-facebook.svg'
import instagram from '../../assets/icon-instagram.svg'
import pins from '../../assets/icon-pinterest.svg'
import twitter from '../../assets/icon-twitter.svg';
import address from "../../assets/map-marker-home.png"
import phone from "../../assets/telephone-cercle.png"
import email from "../../assets/cercle-enveloppe.png"
function Footer() {
    return <div className="bg-footer">
                <div className="contactLiens">
                    <div className="addressFooter">
                        <img src={address} alt="address"  />
                        <div>
                            <h4>NOTRE BUREAU PRINCIPALE</h4>
                            <p>Av.Ruphin Kisilu N°40</p>
                        </div>
                    </div>
                    <div className="phoneFooter">
                        <img  src={phone} alt="phone" />
                        <div>
                            <h4>NUMERO TELEPHONE</h4>
                            <p>+243 892 669 552</p>
                        </div>
                    </div>
                    <div className="emailFooter">
                        <img src={email} alt="email" />
                        <div>
                            <h4>E-MAIL</h4>
                            <p>nzitapuindi2 @gmail.com</p>
                        </div>
                    </div>
                    <div className="lien">
                        <img src={facebook} alt="icone facebook" />
                        <img src={instagram} alt="icone instagrame" />
                        <img src={pins} alt="icon pinsrest" />
                        <img src={twitter} alt="icone twitter" />
                    </div>
                </div>
                <div className="infoDesign">
                    <p>©Copyright in 2023 to Jordache</p>
                    <div className="moi">
                        <p className="moiSecond">Jordache nzita</p>
                        <p>Kollectif Numerique</p>
                    </div>
                </div>
            </div>
}


export default Footer